import React from "react";

export const Breadcrumb = ({ onClick, prev, next }) => {
  return (
    <div className="bg-breadcrumb px-3 py-2 inline-flex items-center gap-2 rounded mb-6 text-f14">
      <span className="text-secondary font-semibold" onClick={onClick}>
        {prev}
      </span>
      <span>
        <svg
          width="8"
          height="14"
          viewBox="0 0 8 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.5 1.16602L6.5 6.99935L1.5 12.8327"
            stroke="#5B8098"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span className="text-secondary ">{next}</span>
    </div>
  );
};
